import { render, staticRenderFns } from "./editUnit.vue?vue&type=template&id=452703b7"
import script from "./editUnit.vue?vue&type=script&lang=js"
export * from "./editUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports